const getBackgroundColor = (checkboxSelected: boolean, isTracked: boolean) => {
  if (checkboxSelected) {
    return "msg-light-blue";
  }

  if (isTracked) {
    return `#FFF7E6`;
  }

  return "secondary-light-grey";
};

export default getBackgroundColor;
